import React from 'react';
import RadioDualComponent from 'shared/components/RadioDualComponent';

const StencilManualPrinting = (props) => {
  const name = 'manual_printing';

  const {
    tooltip,
    parameters,
    className,
    onChangeParameter,
    errorMessage,
    groupName,
    label,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <RadioDualComponent
      name={name}
      label={label}
      tooltip={tooltip}
      onChange={onChange}
      parameters={parameters}
      className={className}
      groupName={groupName}
      labelA="No"
      valueA="0"
      labelB="Yes"
      valueB="1"
      labelClassName="d-block"
      errorMessage={errorMessage} />
  );
};

StencilManualPrinting.defaultProps = {
  tooltip: Spree.helpForParameters.manual_printing,
  label: Spree.translations.parameters.manual_printing,
};

export default StencilManualPrinting;
